import { Grid2, Link, Typography } from "@mui/material";
import { palette } from "../../theme";

import classes from './index.module.scss';

const Footer = ({ linkList = [] }) => {
  return (
    <Grid2
      container
      direction='column'
      className={classes.footer}
      style={{
        backgroundColor: palette.primary.main,
      }}
    >
      <Grid2 container direction='row'>
        {
          linkList.map((link) => {
            return (
              <Grid2>
                <Link to={link.url}>{link.title}</Link>
              </Grid2>
            )
          })
        }
      </Grid2>
      <Grid2 container direction='row'>
        <Typography variant='body2'>
          © 2025 GHMT Online. All rights reserved
        </Typography>
      </Grid2>
    </Grid2>
  )
}

export default Footer;